const isKyndrylViewOnly = (council, council_role) => {
  if (council === "Kyndryl" && council_role === "viewer") {
    return true;
  }
  return false;
};
export default isKyndrylViewOnly;
